import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=163feb6c&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=163feb6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163feb6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('163feb6c')) {
      api.createRecord('163feb6c', component.options)
    } else {
      api.reload('163feb6c', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=163feb6c&scoped=true&", function () {
      api.rerender('163feb6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NMV1k2jn78Dy/JS/comp/DateRangeExt.vue"
export default component.exports